import { gql } from '@apollo/client'

export default gql`
  query GetNumberOfReservationsByUserId(
    $userId: uuid!
    $cutoffTime: timestamptz!
  ) {
    signup: readings_by_participationstate_aggregate(
      args: { reader_user_id: $userId, particiationstate_name: "signup" }
      where: {
        participationevents: {
          reading: {
            readingstart: { _gte: $cutoffTime }
            readingEventStatusName: { _nin: ["Canceled", "Incomplete"] }
          }
        }
      }
    ) {
      aggregate {
        count
      }
    }
    join: readings_by_participationstate_aggregate(
      args: { reader_user_id: $userId, particiationstate_name: "join" }
      where: {
        participationevents: {
          reading: {
            readingstart: { _gte: $cutoffTime }
            readingEventStatusName: { _nin: ["Canceled", "Incomplete"] }
          }
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`
